import React from "react";
import { ThumbnailsBlock } from '../ThumbnailsBlock';

export const ActivitiesBlock = ({ activities, ...props }) => (
    <ThumbnailsBlock thumbnails={activities} {...props} />
)